/* SBST Theme JS */
var T = {
  pl: {
    nav_collection:'Kolekcja', nav_lookbook:'Lookbook', nav_contact:'Kontakt',
    nav_sign_in:'Zaloguj', nav_account:'Konto',
    shop_title:'UBRANIA', shop_subtitle:'Kolekcja',
    add_to_cart:'Dodaj do koszyka', added:'Dodano!', select_size:'Wybierz rozmiar',
    cart_title:'Twój koszyk', cart_empty:'Twój koszyk jest pusty',
    cart_hint:'Dodaj coś z kolekcji', cart_total:'Łącznie', checkout:'Przejdź do kasy',
    cookie_text:'Używamy plików cookie, aby ulepszyć Twoje przeglądanie i analizować ruch. Klikając Akceptuj, wyrażasz zgodę.',
    cookie_accept:'Akceptuj', cookie_decline:'Odrzuć',
    about_h1:'Nie robimy ubrań.', about_h2:'SBST to nie moda. To mindset.', about_body:'Noś jak drugą skórę.',
    footer_nav:'Nawigacja', footer_service:'Obsługa klienta', footer_legal:'Prawne',
    footer_subscribe:'Zapisz się', footer_email:'Twój email', footer_privacy:'Polityka prywatności',
    footer_returns:'Zwroty', footer_shipping:'Wysyłka',
    details:'Szczegóły', size_guide:'Przewodnik rozmiarów', shipping_info:'Dostawa',
    lang_label:'Język', contact_sub:'Skontaktuj się', contact_write:'Napisz do nas', contact_legal:'Dane prawne'
  },
  en: {
    nav_collection:'Collection', nav_lookbook:'Lookbook', nav_contact:'Contact',
    nav_sign_in:'Sign In', nav_account:'Account',
    shop_title:'CLOTHES', shop_subtitle:'Featured Collection',
    add_to_cart:'Add to Cart', added:'Added!', select_size:'Select Size',
    cart_title:'Your Cart', cart_empty:'Your cart is empty',
    cart_hint:'Add something from the collection', cart_total:'Total', checkout:'Checkout',
    cookie_text:'We use cookies to enhance your browsing experience and analyze site traffic. By clicking Accept, you consent.',
    cookie_accept:'Accept', cookie_decline:'Decline',
    about_h1:"We don't make clothes.", about_h2:"SBST is not fashion. It's a mindset.", about_body:'Wear it like a second skin.',
    footer_nav:'Navigation', footer_service:'Client Services', footer_legal:'Legal',
    footer_subscribe:'Subscribe', footer_email:'Your email', footer_privacy:'Privacy Policy',
    footer_returns:'Returns', footer_shipping:'Shipping',
    details:'Details', size_guide:'Size Guide', shipping_info:'Shipping & Delivery',
    lang_label:'Language', contact_sub:'Get in touch', contact_write:'Reach us', contact_legal:'Legal information'
  },
  es: {
    nav_collection:'Colección', nav_lookbook:'Lookbook', nav_contact:'Contacto',
    nav_sign_in:'Iniciar sesión', nav_account:'Cuenta',
    shop_title:'ROPA', shop_subtitle:'Colección Destacada',
    add_to_cart:'Añadir al Carrito', added:'Añadido!', select_size:'Seleccionar Talla',
    cart_title:'Tu Carrito', cart_empty:'Tu carrito está vacío',
    cart_hint:'Añade algo de la colección', cart_total:'Total', checkout:'Finalizar Compra',
    cookie_text:'Usamos cookies para mejorar tu experiencia. Al hacer clic en Aceptar, consientes el uso de cookies.',
    cookie_accept:'Aceptar', cookie_decline:'Rechazar',
    about_h1:'No hacemos ropa.', about_h2:'SBST no es moda. Es una mentalidad.', about_body:'Llévalo como una segunda piel.',
    footer_nav:'Navegación', footer_service:'Atención al cliente', footer_legal:'Legal',
    footer_subscribe:'Suscríbete', footer_email:'Tu email', footer_privacy:'Privacidad',
    footer_returns:'Devoluciones', footer_shipping:'Envíos',
    details:'Detalles', size_guide:'Guía de tallas', shipping_info:'Envío y entrega',
    lang_label:'Idioma', contact_sub:'Ponte en contacto', contact_write:'Escríbenos', contact_legal:'Información legal'
  },
  it: {
    nav_collection:'Collezione', nav_lookbook:'Lookbook', nav_contact:'Contatti',
    nav_sign_in:'Accedi', nav_account:'Account',
    shop_title:'ABBIGLIAMENTO', shop_subtitle:'Collezione',
    add_to_cart:'Aggiungi al carrello', added:'Aggiunto!', select_size:'Seleziona la taglia',
    cart_title:'Il tuo carrello', cart_empty:'Il tuo carrello è vuoto',
    cart_hint:'Aggiungi qualcosa dalla collezione', cart_total:'Totale', checkout:'Vai alla cassa',
    cookie_text:'Utilizziamo i cookie per migliorare la tua esperienza e analizzare il traffico. Cliccando Accetta, acconsenti.',
    cookie_accept:'Accetta', cookie_decline:'Rifiuta',
    about_h1:'Non facciamo vestiti.', about_h2:'SBST non è moda. È un mindset.', about_body:'Indossalo come una seconda pelle.',
    footer_nav:'Navigazione', footer_service:'Servizio clienti', footer_legal:'Legale',
    footer_subscribe:'Iscriviti', footer_email:'La tua email', footer_privacy:'Privacy',
    footer_returns:'Resi', footer_shipping:'Spedizioni',
    details:'Dettagli', size_guide:'Guida alle taglie', shipping_info:'Spedizione e consegna',
    lang_label:'Lingua', contact_sub:'Contattaci', contact_write:'Scrivici', contact_legal:'Informazioni legali'
  }
};
Object.assign(T.pl, { shop_title:'KOLEKCJA', ship_region:'REGION', ship_time:'CZAS', ship_price:'CENA', ship_pl:'Polska', ship_eu:'Europa', ship_world:'Reszta świata', ship_t_fast:'2–3 dni', ship_t_eu:'5–7 dni', ship_t_world:'7–14 dni', ship_free:'Darmowa dostawa przy zamówieniach powyżej 300 zł.', ship_returns:'Zwroty do 14 dni od otrzymania.', sg_a:'A — całkowita długość bluzy mierzona od ramienia', sg_b:'B — szerokość bluzy (obwód to 2 x wartość z tabeli)', sg_c:'C — długość rękawa bez ramienia', sg_tol:'Tolerancja +/- 2 cm' });
Object.assign(T.en, { shop_title:'COLLECTION', ship_region:'REGION', ship_time:'TIME', ship_price:'PRICE', ship_pl:'Poland', ship_eu:'Europe', ship_world:'Rest of the world', ship_t_fast:'2–3 days', ship_t_eu:'5–7 days', ship_t_world:'7–14 days', ship_free:'Free shipping on orders over 300 zł.', ship_returns:'Returns within 14 days of delivery.', sg_a:'A — total length measured from the shoulder', sg_b:'B — width (circumference is 2 x table value)', sg_c:'C — sleeve length without the shoulder', sg_tol:'Tolerance +/- 2 cm' });
Object.assign(T.es, { shop_title:'COLECCIÓN', ship_region:'REGIÓN', ship_time:'TIEMPO', ship_price:'PRECIO', ship_pl:'Polonia', ship_eu:'Europa', ship_world:'Resto del mundo', ship_t_fast:'2–3 días', ship_t_eu:'5–7 días', ship_t_world:'7–14 días', ship_free:'Envío gratis en pedidos superiores a 300 zł.', ship_returns:'Devoluciones hasta 14 días desde la entrega.', sg_a:'A — largo total medido desde el hombro', sg_b:'B — ancho (el contorno es 2 x el valor de la tabla)', sg_c:'C — largo de la manga sin el hombro', sg_tol:'Tolerancia +/- 2 cm' });
Object.assign(T.it, { shop_title:'COLLEZIONE', ship_region:'REGIONE', ship_time:'TEMPI', ship_price:'PREZZO', ship_pl:'Polonia', ship_eu:'Europa', ship_world:'Resto del mondo', ship_t_fast:'2–3 giorni', ship_t_eu:'5–7 giorni', ship_t_world:'7–14 giorni', ship_free:'Spedizione gratuita per ordini superiori a 300 zł.', ship_returns:'Resi entro 14 giorni dalla consegna.', sg_a:'A — lunghezza totale misurata dalla spalla', sg_b:'B — larghezza (la circonferenza è 2 x il valore in tabella)', sg_c:'C — lunghezza della manica senza la spalla', sg_tol:'Tolleranza +/- 2 cm' });
Object.assign(T.pl, { sg_size:'Rozmiar', sg_legend:'LEGENDA: (wszystkie wymiary podane w centymetrach)', c_phone:'TELEFON', c_email:'EMAIL', c_addr:'ADRES', l_trade:'NAZWA HANDLOWA', l_company:'FIRMA' });
Object.assign(T.en, { sg_size:'Size', sg_legend:'KEY: (all measurements in centimeters)', c_phone:'PHONE', c_email:'EMAIL', c_addr:'ADDRESS', l_trade:'TRADE NAME', l_company:'COMPANY' });
Object.assign(T.es, { sg_size:'Talla', sg_legend:'LEYENDA: (todas las medidas en centímetros)', c_phone:'TELÉFONO', c_email:'EMAIL', c_addr:'DIRECCIÓN', l_trade:'NOMBRE COMERCIAL', l_company:'EMPRESA' });
Object.assign(T.it, { sg_size:'Taglia', sg_legend:'LEGENDA: (tutte le misure in centimetri)', c_phone:'TELEFONO', c_email:'EMAIL', c_addr:'INDIRIZZO', l_trade:'NOME COMMERCIALE', l_company:'AZIENDA' });
Object.assign(T.pl, { det_1:'Gruby materiał 340g.', det_2:'Krój relaxed fit, unisex.', det_3:'Czysty, minimalistyczny design.', det_4:'W całości zaprojektowane i uszyte w Polsce.', det_5:'90% bawełna, 10% poliester' });
Object.assign(T.en, { det_1:'Heavy 340g fabric.', det_2:'Relaxed fit, unisex.', det_3:'Clean, minimalist design.', det_4:'Fully designed and made in Poland.', det_5:'90% cotton, 10% polyester' });
Object.assign(T.es, { det_1:'Tejido grueso de 340g.', det_2:'Corte relaxed fit, unisex.', det_3:'Diseño limpio y minimalista.', det_4:'Diseñado y confeccionado íntegramente en Polonia.', det_5:'90% algodón, 10% poliéster' });
Object.assign(T.it, { det_1:'Tessuto pesante da 340g.', det_2:'Vestibilità relaxed, unisex.', det_3:'Design pulito e minimalista.', det_4:'Interamente disegnato e cucito in Polonia.', det_5:'90% cotone, 10% poliestere' });
Object.assign(T.pl, { curr_label:'Waluta' });
Object.assign(T.en, { curr_label:'Currency' });
Object.assign(T.es, { curr_label:'Moneda' });
Object.assign(T.it, { curr_label:'Valuta' });
var lang = localStorage.getItem('sbst-lang') || 'pl';

function t(k){ return (T[lang]&&T[lang][k])||k; }
var curr = localStorage.getItem('sbst-curr') || 'pln';
var CURRENCIES = { pln:{s:'zł',r:1}, usd:{s:'$',r:0.25}, eur:{s:'€',r:0.23} };
function fmt(pln){ var c=CURRENCIES[curr], v=Math.round(pln*c.r); return curr==='pln'?v+' zł':c.s+v; }
function applyCurr(){
  document.querySelectorAll('.curr-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.curr===curr); });
  document.querySelectorAll('[data-pln]').forEach(function(el){ el.textContent=fmt(parseInt(el.getAttribute('data-pln'),10)/100); });
}
function setCurr(c){ curr=c; localStorage.setItem('sbst-curr',c); applyCurr(); renderCart(); }

function applyLang(){
  document.querySelectorAll('[data-i18n]').forEach(function(el){ el.textContent=t(el.getAttribute('data-i18n')); });
  document.querySelectorAll('[data-i18n-ph]').forEach(function(el){ el.placeholder=t(el.getAttribute('data-i18n-ph')); });
  document.querySelectorAll('.lang-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.lang===lang); });
}
function setLang(l){ lang=l; localStorage.setItem('sbst-lang',l); applyLang(); renderCart(); if(window.applyPolicyLang)applyPolicyLang(); }
/* NAV */
function openMenu(){ document.getElementById('menu-overlay').classList.add('open'); document.getElementById('slide-menu').classList.add('open'); }
function closeMenu(){ document.getElementById('menu-overlay').classList.remove('open'); document.getElementById('slide-menu').classList.remove('open'); }

/* CART */
var cartData = {items:[],total_price:0};
window.refreshCart = async function(){
  var r = await fetch('/cart.js'); cartData = await r.json(); renderCart();
};
function renderCart(){
  var ti=document.getElementById('cart-items'), tf=document.getElementById('cart-foot'), tc=document.getElementById('cart-count'), ta=document.getElementById('cart-total-amt');
  var count = cartData.items ? cartData.items.reduce(function(a,i){return a+i.quantity;},0) : 0;
  if(tc){ tc.textContent=count; tc.style.display=count>0?'flex':'none'; }
  var title=document.querySelector('.cart-title'); if(title) title.textContent=t('cart_title');
  if(!ti) return;
  if(!cartData.items||cartData.items.length===0){
    ti.innerHTML='<div class="cart-empty"><p>'+t('cart_empty')+'</p><p>'+t('cart_hint')+'</p></div>';
    if(tf) tf.style.display='none';
  } else {
    ti.innerHTML=cartData.items.map(function(item){
      return '<div class="cart-item" data-key="'+item.key+'">'
        +'<div class="ci-img"><img src="'+item.image+'" alt="'+item.product_title+'" loading="lazy"></div>'
        +'<div class="ci-info">'
        +'<p class="ci-name">'+item.product_title+'</p>'
        +(item.variant_title?'<p class="ci-size">'+item.variant_title+'</p>':'')
        +'<p class="ci-price">'+fmt(item.price/100)+'</p>'
        +'<div class="ci-qty">'
        +'<button onclick="chQty(\''+item.key+'\','+( item.quantity-1)+')">−</button>'
        +'<span>'+item.quantity+'</span>'
        +'<button onclick="chQty(\''+item.key+'\','+(item.quantity+1)+')">+</button>'
        +'</div></div></div>';
    }).join('');
    if(tf){ tf.style.display='flex'; }
    if(ta) ta.textContent=fmt(cartData.total_price/100);
    var tl=document.querySelector('[data-i18n="cart_total"]'); if(tl) tl.textContent=t('cart_total');
    var cb=document.querySelector('.checkout-btn'); if(cb) cb.textContent=t('checkout');
  }
}
async function chQty(key,qty){
  if(qty<0) return;
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
  await window.refreshCart();
}
function openCart(){ document.getElementById('cart-drawer').classList.add('open'); document.getElementById('cart-overlay').classList.add('open'); document.body.style.overflow='hidden'; }
function closeCart(){ document.getElementById('cart-drawer').classList.remove('open'); document.getElementById('cart-overlay').classList.remove('open'); document.body.style.overflow=''; }

/* HERO PARALLAX */
function initParallax(){
  var bg=document.querySelector('.hero-bg');
  if(!bg)return;
  var ticking=false;
  window.addEventListener('scroll',function(){
    if(!ticking){
      requestAnimationFrame(function(){
        bg.style.transform='scale(1.1) translateY('+(window.scrollY/window.innerHeight*30)+'%)';
        ticking=false;
      });
      ticking=true;
    }
  },{passive:true});
}

/* SCROLL FADE */
function initFade(){
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var el=e.target, d=parseInt(el.dataset.delay||0);
        setTimeout(function(){ el.classList.add('visible'); },d);
        obs.unobserve(el);
      }
    });
  },{threshold:0.1});
  document.querySelectorAll('.fade-in,.fade-up,.fade-left,.fade-right').forEach(function(el){ obs.observe(el); });
}

/* COOKIE */
function initCookie(){
  if(localStorage.getItem('sbst-cookies')) return;
  var b=document.getElementById('cookie-banner');
  if(b) setTimeout(function(){ b.classList.add('show'); },2000);
}
function acceptCookies(){ localStorage.setItem('sbst-cookies','1'); document.getElementById('cookie-banner').classList.remove('show'); }
function declineCookies(){ localStorage.setItem('sbst-cookies','0'); document.getElementById('cookie-banner').classList.remove('show'); }

/* PRODUCT CARD HOVER IMAGE */
function initCards(){
  document.querySelectorAll('.product-card').forEach(function(card){
    var i1=card.querySelector('.card-img-1'), i2=card.querySelector('.card-img-2');
    if(!i1||!i2) return;
    card.addEventListener('mouseenter',function(){ i1.style.opacity='0'; i2.style.opacity='1'; });
    card.addEventListener('mouseleave',function(){ i1.style.opacity='1'; i2.style.opacity='0'; });
  });
}

document.addEventListener('DOMContentLoaded', function(){
  applyLang();
  applyCurr();
  initParallax();
  initFade();
  initCards();
  initCookie();
  window.refreshCart();
});                             
